export default "__VITE_ASSET__B3JJzE$w__"